import React from 'react';

const InputSuccessMessage = (props) => {
    return (
        <p className='mb-3' style={{ color: '#87B04B' }}>
            {props.message}
        </p>
    );
};

export default InputSuccessMessage;
